import {
  useAiChatContext,
  useSimulationContext,
} from '@app-velocity/modules/scenarios';

import { SignUpNotice } from '@app-velocity/ui';
import { useI18n } from '@app-velocity/i18n';

export const GuestNotice = () => {
  const { review } = useAiChatContext();
  const { mode } = useSimulationContext();
  const { t } = useI18n();

  if (mode !== 'guest') return null;

  if (
    !review?.reviewStatus ||
    !['COMPLETED', 'CANCELED'].includes(review.reviewStatus)
  )
    return null;

  const isReviewFinished = review.reviewStatus === 'COMPLETED';

  return (
    <SignUpNotice
      title={
        isReviewFinished
          ? 'prototypes:guest_notice.finished_title'
          : 'prototypes:guest_notice.title'
      }
      text={
        isReviewFinished
          ? 'prototypes:guest_notice.finished_text'
          : 'prototypes:guest_notice.text'
      }
      badge={t('prototypes:guest_notice.badge')}
      action="prototypes:get_full_simulation"
    />
  );
};
